import { Layout, Section } from 'layout';
import { SupplierProfilesListScreen } from 'pages/supplier-profiles/screens/supplier-profiles-list-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const SupplierProfilesPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}/list`} component={SupplierProfilesListScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default SupplierProfilesPage;
